import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {SubtabItemActiveColorScheme} from './constants';
import {SubTabItemProps} from './SubTabItemProps.interface';

export function SubTabItem({
  className,
  isActive,
  children,
  activeColorScheme = SubtabItemActiveColorScheme['1st'],
  ...props
}: SubTabItemProps) {
  return (
    <div
      className={twMerge(
        'flex h-30pxr w-fit-content cursor-pointer select-none items-center rounded-32pxr px-12pxr text-theme-solid-60',
        isActive && activeColorSchemeToStyle[activeColorScheme],
        className
      )}
      {...props}
    >
      <Text className={isActive ? 'font-medium2-bold' : 'font-medium2'}>
        {children}
      </Text>
    </div>
  );
}

const activeColorSchemeToStyle = {
  [SubtabItemActiveColorScheme['1st']]: 'bg-theme-solid-100 text-theme-solid-0',
  [SubtabItemActiveColorScheme['2nd']]:
    'bg-theme-solid-20 text-theme-solid-100',
};
